import { render, staticRenderFns } from "./RootFolder.vue?vue&type=template&id=bcae0b5e&"
import script from "./RootFolder.vue?vue&type=script&lang=js&"
export * from "./RootFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports